import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const KlarnaModalList = ({
  image = false,
  imageAlt = false,
  last = false,
  message,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="container">
        <div className="message-container">
          {!last && <div className="list-line" />}
          <div className="rectangle">
            <svg focusable="false" height="10" width="10">
              <rect fill="#171717" height="10" width="10" />
            </svg>
          </div>
        </div>
        {!image && <div className="message-text">{message}</div>}
        {image && (
          <div className="message-text">
            {message}
            <div className="klarna-image">
              <img alt={imageAlt} height="30px" src={image} width="60px" />
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .container {
          align-items: center;
          box-sizing: border-box;
          display: flex;
          align-items: stretch;
          flex-direction: row;
          flex-shrink: 0;
          border-style: solid;
          border-width: 0px;
          position: relative;
          z-index: 0;
          min-height: 0px;
          min-width: 0px;
          font-size: 16px;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .container {
           padding 0 5px;
          }
        }
        .message-container {
          position: relative;
        }
        .list-line {
          background-color: #f0eeeb;
          flex-direction: column;
          height: 100%;
          left: 4px;
          position: absolute;
          top: 20px;
          width: 2px;
        }
        .rectangle {
          display: flex;
          padding: 15px 15px 0 0;
          position: relative;
          z-index: 0;
        }
        .message-text {
          display: flex;
          flex-shrink: 1;
          padding: 10px 0 20px 0;
        }
        .klarna-image {
          padding: 0 0 0 10px;
        }
      `}</style>
    </>
  );
};

KlarnaModalList.propTypes = {
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  last: PropTypes.bool,
  message: PropTypes.string,
};

export default KlarnaModalList;
